import React from "react"

const QuickorderHead = ( ) => {
  return (
   <React.Fragment>
     <colgroup>
       <col width="30"/>
       <col width=""/>
       <col width="20%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
     </colgroup>
     <thead>
     <tr>
       <th>&nbsp;</th>
       <th>{translate( "article" )}</th>
       <th>&nbsp;</th>
       <th>{translate( "deliverable" )}</th>
       <th>{translate("Preis/Stück")}</th>
       <th>{translate("Preis/VE")}</th>
       <th>{translate( "total count" )}</th>
       <th>{translate( "sum" )}</th>
       <th>{translate( "PU" )}</th>
       <th style={{ textAlign: "right" }}>{translate( "amount (VE)" )}</th>
     </tr>
     </thead>
   </React.Fragment>
  )
}


export default QuickorderHead


// WEBPACK FOOTER //
// ./src/components/Quickorder/QuickorderHead.js